<template>
  <v-dialog v-model="dialog" persistent width="1500px">
    <v-toolbar dark class="gradient-bg2">
      <v-toolbar-items
        ><v-toolbar-title class="white--text titcss ml-3 mt-2"
          >Upload</v-toolbar-title
        >
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <v-btn class="" text dark @click="cleardata">
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card>
      <v-row class="mx-3">
        <v-col cols="12" md="3">
          <v-row>
            <v-select
              shaped
              outlined
              label="Name"
              v-model="Name"
              :items="headerList"
              dense
            >
            </v-select> </v-row
          ><v-row>
            <v-select
              shaped
              outlined
              label="Mobile Number"
              v-model="MobNo"
              :items="headerList"
              dense
            >
            </v-select> </v-row
          ><v-row>
            <v-select
              shaped
              outlined
              label="Proxy Number"
              v-model="ProxyNumber"
              :items="headerList"
              dense
            >
            </v-select>
          </v-row>
          <v-row>
            <v-select
              shaped
              outlined
              label="Payment Reason"
              v-model="Reason"
              :items="headerList"
              dense
            >
            </v-select>
          </v-row>
          <v-row>
            <v-select
              shaped
              outlined
              label="Amount"
              v-model="Amount"
              :items="headerList"
              dense
            >
            </v-select>
          </v-row>
          <v-row>
            <v-select
              shaped
              outlined
              label="Currency"
              v-model="Currency"
              :items="headerList"
              dense
            >
            </v-select>
          </v-row>
          <v-row justify="center">
            <v-spacer />
            <v-btn
              v-if="
                Name != '' &&
                MobNo != '' &&
                ProxyNumber != '' &&
                Reason != '' &&
                Amount != '' &&
                Currency != ''
              "
              @click="ConstructTableMethod()"
              class="gradient-bg white--text"
              shaped
              dark
              tile
              >Preview</v-btn
            >
          </v-row>
        </v-col>
        <v-col cols="12" md="9">
          <v-card
            v-if="headerList.length != 0 && StoreTableData.length != 0"
            flat
          >
            <v-tabs v-model="model" centered slider-color="primary">
              <v-tab>Valid</v-tab>
              <v-tab>Invalid</v-tab>
            </v-tabs>
            <v-tabs-items v-model="model">
              <v-tab-item>
                <v-card flat v-if="model == 0">
                  <v-data-table
                    :headers="ValidHeader"
                    dense
                    :items="UploadList.valid"
                  >
                  </v-data-table>
                  <v-card-actions></v-card-actions>
                  <v-card-actions>
                    <v-row justify="center">
                      <v-btn
                        @click="updateMember"
                        :loading="isLoadingUpload"
                        class="gradient-bg white--text"
                        ><v-icon class="mr-2">mdi-upload</v-icon> Upload
                      </v-btn>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat v-if="model == 1">
                  <v-data-table
                    :headers="InValidHeader"
                    dense
                    :items="UploadList.invalid"
                  >
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-tooltip bottom color="primary">
                        <template v-slot:activator="{ on }">
                          <v-icon
                            small
                            v-on="on"
                            class="gradient-btn mr-5"
                            @click="editItem(item)"
                          >
                            mdi-pencil
                          </v-icon>
                        </template>
                        <span class="white--text">Edit Employee Details</span>
                      </v-tooltip>
                      <v-tooltip bottom color="primary">
                        <template v-slot:activator="{ on }">
                          <v-icon
                            small
                            v-on="on"
                            class="gradient-btn mr-5"
                            @click="deleteitem(item)"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                        <span class="white--text">Delete current record</span>
                      </v-tooltip>
                    </template>
                    <template v-slot:top>
                      <v-spacer></v-spacer>
                      <v-dialog v-model="dialogEdited" max-width="600px">
                        <v-card flat>
                          <v-toolbar dark class="gradient-bg2">
                            <v-toolbar-items
                              ><v-card-title>
                                <span class="white--text titcss"
                                  >Edit Member</span
                                >
                              </v-card-title>
                            </v-toolbar-items>
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="white"
                              dark
                              @click="dialogEdited = false"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </v-toolbar>
                          <v-form
                            ref="form"
                            v-model="valid"
                            :lazy-validation="lazy"
                          >
                            <v-card-text>
                              <v-row class="mx-3">
                                <v-text-field
                                  v-model="item['Name']"
                                  :rules="idrules"
                                  color="primary"
                                  label="Name"
                                ></v-text-field>
                              </v-row>
                              <v-row class="mx-3">
                                <v-text-field
                                  v-model="item['Phone']"
                                  :rules="namerules"
                                  color="primary"
                                  label="Mobile Number"
                                ></v-text-field>
                              </v-row>
                              <v-row class="mx-3">
                                <v-text-field
                                  :rules="numberRules"
                                  v-model="item['Proxy']"
                                  color="primary"
                                  label="Proxy Number"
                                ></v-text-field>
                              </v-row>
                              <v-row class="mx-3">
                                <v-text-field
                                  :rules="numberRules"
                                  v-model="item['Reason']"
                                  color="primary"
                                  label="Payment Reason"
                                ></v-text-field>
                              </v-row>
                              <v-row class="mx-3">
                                <v-text-field
                                  :rules="numberRules"
                                  v-model="item['Amount']"
                                  color="primary"
                                  label="Amount"
                                ></v-text-field>
                              </v-row>
                              <v-row class="mx-3">
                                <v-text-field
                                  :rules="numberRules"
                                  v-model="item['Currency']"
                                  color="primary"
                                  label="Currencyr"
                                ></v-text-field>
                              </v-row>
                            </v-card-text>

                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                class="gradient-bg white--text mr-7 mb-8"
                                @click="ValidateAddDialog"
                                :loading="isLoadingEdit"
                                ><v-icon small class="mr-3"
                                  >mdi-content-save</v-icon
                                >
                                Save Details</v-btn
                              >
                            </v-card-actions>
                          </v-form>
                        </v-card>
                      </v-dialog>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
          <v-card v-else class="elevation-0">
            <v-card-actions class="">
              <v-spacer />
              <v-card-actions class="mt-n10">
                <v-spacer />
              </v-card-actions>
            </v-card-actions>
            <v-card-title
              class="font-weight-regular text-center FontSize py-16 px-1"
              >Please Select The Respective Column Headers For
              <div class="ml-1 primary--text">
                Name, Mobile Number, Proxy Number, Payment Reason, Amount &
                Currency
              </div>
              From The Excel Sheet For Preview.
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
// import CountryList from "@/mixins/CountryList.json";
// import { BTable } from "bootstrap-vue";
// import { API, graphqlOperation } from "aws-amplify";
// import { bulkuploademployees } from "@/graphql/mutations.js";

export default {
  // components: {
  //   BTable,
  // },
  props: {
    EditUploadDialog: Boolean,
    // UploadList: Array,
    // ValidData: Array,
  },
  data: () => ({
    dialog: false,

    isLoadingUpload: false,
    valid: true,
    // getfunc:false,
    lazy: false,
    Snackbar: false,
    SnackbarText: "",
    color: "",
    Name: "",
    MobNo: "",
    ProxyNumber: "",
    Reason: "",
    Amount: "",
    Currency: "",

    namerules: [
      (EmployeeName) => {
        if (EmployeeName.trim() === "") return "Employee Name cannot be empty";
        return true;
      },
      (x) => /^[a-zA-Z]+(\s[a-zA-Z]+)*$/.test(x) || "Enter Valid Name",
      (x) => x.length <= 20 || "Enter within 20 characters",
    ],
    idrules: [
      (Employee_Id) => {
        if (Employee_Id.trim() === "") return "Employee ID cannot be empty";
        return true;
      },
      (x) =>
        /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/.test(x) ||
        "Enter at least 1 alphabet and 1 number",
      (x) => x.length <= 10 || "Enter within 10 characters",
    ],
    exceldata: { tabledata: null, tableheader: null },

    numberRules: [
      (x) => x.length == 10 || "Please enter a valid number",
      (x) => /^[0-9]+$/.test(x) || "Enter only numbers",
    ],

    dialogEdited: false,
    item: {},
    isLoadingEdit: false,
    UploadList: [],
    editedItem: {
      Name: "",
      Employee_ID: "",
      // CountryCode: "",
      Contact_Number: "",
    },
    StoreTableData: [],
    StoreValidUserArray: [],
    ExcelList: ["EmployeeName", "EmployeeId", "CountryCode", "ContactNum"],
    model: 0,
    ValidHeader: [],
    InValidHeader: [],
    ValidData: [],
    ValidList: [],
    headerList: [],
    swipelist: [],

    list: [
      {
        Id: "Frozen Yogurt",
        Title: 159,
        Author: 6.0,
        Readings: 24,
        Date: 4.0,
      },
    ],
    dataList: [],
    InvalidData: [],
    InvalidList: [],

    numberRegEx: "/^[0-9]+$/",
  }),
  computed: {},

  mounted() {
    // console.log("userList", this.UploadList.ValidList);
    // this.GetCurrentCountry();
  },
  created() {
    // this.CountryListDetails();
  },
  methods: {
    cleardata() {
      (this.Name = ""),
        (this.MobNo = ""),
        (this.ProxyNumber = ""),
        (this.Reason = ""),
        (this.Amount = ""),
        (this.Currency = "");
    },

    ValidateAddDialog() {
      if (this.$refs.form.validate()) {
        //   console.log("logggggg", this.item);
        this.UploadList.valid.push(this.item);
        //  console.log("pushhh", this.UploadList.valid);
        this.UploadList.invalid.splice(this.item, 1);
        // this.$refs.getfunc.getMembers();
        this.dialogEdited = false;
      } else {
        this.Snackbar = true;
        this.SnackbarText = "Please enter all the fields";
        this.color = "red";
      }
    },
    deleteitem() {
      this.UploadList.invalid.splice(this.item, 1);
    },
    // test() {
    //   console.log(this.editedItem.CountryCode.dial_code);
    // },

    // GetCurrentCountry() {
    //   fetch("https://extreme-ip-lookup.com/json/")
    //     .then((res) => res.json())
    //     .then((response) => {
    //       console.log(response);
    //       this.dial_code = response.country;
    //       var self = this;
    //       self.CountryList.forEach(function (CountryIDX) {
    //         if (CountryIDX.name == response.country) {
    //           self.CountryCode = CountryIDX.dial_code;
    //         }
    //       });
    //     })
    //     .catch((data, status) => {
    //       console.log("Request failed data", data);
    //       console.log("Request failed status", status);
    //     });
    // },
    getexceldata(table) {
      // parent call
      this.dialog = true;
      this.headerList = table.tableheader;
      this.dataList = table.tabledata;
    },
    ConstructTableMethod() {
      this.ValidHeader = [
        { text: "Name", value: this.Name },
        { text: "Mobile Number", value: this.MobNo },
        { text: "Proxy Number", value: this.ProxyNumber },
        { text: "Payment Reason", value: this.Reason },
        { text: "Amount", value: this.Amount },
        { text: "Currency", value: this.Currency },
      ];
      this.InValidHeader = [
        { text: "Name", value: this.Name },
        { text: "Mobile Number", value: this.MobNo },
        { text: "Proxy Number", value: this.ProxyNumber },
        { text: "Payment Reason", value: this.Reason },
        { text: "Amount", value: this.Amount },
        { text: "Currency", value: this.Currency },
        {
          text: "Actions",
          value: "actions",
          width: "auto",
          align: "center",
          sortable: false,
        },
      ];
      this.StoreTableData = this.dataList;
      // var self = this;
      // self.StoreTableData.forEach(function (findx) {
      //   if (findx[self.CountryCode] != undefined) {
      //     findx[self.CountryCode] = "+" + findx[self.CountryCode];
      //   }
      // });
      //    console.table("Table Data", this.StoreTableData);
      this.filterUserTable();
    },
    filterUserTable() {
      this.UploadList = {
        valid: [],
        invalid: [],
      };
      this.StoreTableData.forEach((user) => {
        let valid = true;
        this.ValidHeader.forEach((header) => {
          // console.log(header)
          // console.log(user[header.value])
          if (!user[header.value] && valid) {
            valid = false;
            //    console.log(user);
            this.UploadList.invalid.push(user);
          }
        });
        if (valid) this.UploadList.valid.push(user);
      });
    },
    updateuploaddetails() {
      //   console.log("logggggg", this.item);
      this.UploadList.valid.push(this.item);
      //   console.log("pushhh", this.UploadList.valid);
      this.UploadList.invalid.splice(this.item, 1);
      this.dialogEdited = false;
    },
    editItem(item) {
      //  console.log("qwertyu", item);
      this.dialogEdited = true;
      (this.item["Name"] = item["Name"]),
        (this.item["Phone"] = item["Phone"]),
        (this.item["Proxy"] = item["Proxy"]),
        (this.item["Reason"] = item["Reason"]);
      this.item["Amount"] = item["Amount"];
      this.item["Currency"] = item["Currency"];
    },
    // async updateMember() {
    //   this.isLoadingUpload = true;

    //   console.log("update Members");

    //   let StoreValidUser = this.UploadList.valid;
    //   const self = this;
    //   const StoreValidUserArray = StoreValidUser.map((user) => {
    //     return {
    //       Name: user[self.EmpName],
    //       Employee_ID: user[self.EmpId],
    //       CountryCode: user[self.CountryCode],
    //       Contact_Number: user[self.ContNum],
    //       Phoneno: user[self.CountryCode] + user[self.ContNum],
    //     };
    //   });

    //   try {
    //     var inputParams = {
    //       Org_ID: this.$store.getters.get_org_details.Organisation_Id,
    //       Prezence_Employee: JSON.stringify(StoreValidUserArray),
    //     };
    //     console.log("Check the input params", inputParams);
    //     let result = await API.graphql(
    //       graphqlOperation(bulkuploademployees, {
    //         input: inputParams,
    //       })
    //     ).then((response) => {
    //       console.log("result edited members", response, result);
    //       // console.log();
    //       this.closeEditUploadDialog();
    //     });
    //   } catch (e) {
    //     this.loading = false;
    //     this.$store.commit("snackbar/showMessage", {
    //       content: `Unable to add Member Details!! Try again after sometime! `,
    //       color: "red",
    //     });
    //     console.log(e);
    //   }
    // },
    closeEditUploadDialog() {
      this.$store.commit("snackbar/showMessage", {
        content: `Succesfully Edited Member Details`,
        color: "green",
      });
      this.dialog = false;
      this.isLoadingUpload = false;

      (this.Name = ""),
        (this.MobNo = ""),
        (this.ProxyNumber = ""),
        (this.Reason = ""),
        (this.Amount = ""),
        (this.Currency = "");
      (this.headerList = ""), (this.StoreTableData = ""), this.$emit("refresh");
    },
  },
};
</script>

<style>
</style>